module.exports = __webpack_public_path__ + "img/icon-phone-1.9be4e4e4.png";